import { getSession } from "utils/TokenUtils/getSession";
import { getCurrentUser } from "utils/TokenUtils/getCurrentUser";
import { refreshToken } from "utils/TokenUtils/refreshToken";

export async function refreshUserSession(): Promise<any> {
	const currentUser = getCurrentUser();
	return getSession(currentUser)
		.then((session) => {
			return refreshToken(currentUser, session.getRefreshToken().getToken());
		})
		.catch((err) => err);
}
